// Check if the items is in the cart
export const isItemInCart = (items, item) => {
    return items.some((cartItem) => {
        return cartItem.product_id === item.id;
    });
};

// Check the type of the cart
export const isMaintenanceInCart = (items) => {
    return items.some((cartItem) => {
        return cartItem.type === "maintenance";
    });
};

// Sum all the quantity
export const sumQuantityInCart = (items) => {
    return items.reduce((acc, item) => {
        return acc + item.quantity;
    }, 0);
};
